import React from 'react'

import { Link } from 'react-router-dom';

import { Carousel } from 'antd'

// import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';

import icon1 from '../../assets/images/banner/icon01.png'
import icon2 from '../../assets/images/banner/icon02.png'
import icon3 from '../../assets/images/banner/icon03.png'

import proIconHover1 from '../../assets/images/home/icon01.png'
import proIcon1 from '../../assets/images/home/icon01-hover.png'
import proIconHover2 from '../../assets/images/home/icon02.png'
import proIcon2 from '../../assets/images/home/icon02-hover.png'
import proIconHover3 from '../../assets/images/home/icon03.png'
import proIcon3 from '../../assets/images/home/icon03-hover.png'
import proIconHover4 from '../../assets/images/home/icon04.png'
import proIcon4 from '../../assets/images/home/icon04-hover.png'

import styles from './index.module.scss'
import { TOOLS } from 'constantss';

const bannerList = [
    // {
    //     index: 0,
    //     type: 'tool',
    //     title: '一站式应用开发工具集',
    //     content: '一站式应用开发工具集，实现工具集间流程贯连，数据互联，自动智能，协助共享',
    //     background: TOOLS.FITONE_MP4
    // },
    {
        index: 1,
        type: 'NetworkSafety',
        title: '网络安全',
        content: '构建全域风险感知、预警、处置能力，筑牢网络空间防线、打击网络犯罪。'
    },
    {
        index: 2,
        type: 'SmartPolicing',
        title: '智慧警务',
        content: '以警务大数据平台为基座打造专业警种解决方案，提升社会治理现代化水平。'
    },
    {
        index: 3,
        type: 'SmartGovernment',
        title: '智慧政务',
        content: '创新数字化社会治理，守护城市安全，精准服务民生，助力政府高效管理城市。'
    },
    {
        index: 4,
        type: 'DigitalTransformation',
        title: '企业数字化转型',
        content: '打造全流程数字化管理，掌握企业运营全景，提升企业核心竞争力。'
    }
];

const recommendList = [
    {
        index: 1,
        title: '精选方案',
        tip: '一站式服务解决方案',
        src: icon1,
        key: 'solution'
    },
    {
        index: 2,
        title: '推荐产品',
        tip: '助力企业降本增效',
        src: icon2,
        key: 'production'
    },
    {
        index: 3,
        title: '敬请期待',
        tip: '...',
        src: icon3
    }
];

const productionList = [
  {
    index: 1,
    icon: proIcon1,
    iconActive: proIconHover1,
    title: '大数据智能化产品',
    content:
      '大数据智能化系列产品作为行业解决方案的核心技术支撑，主要包括大数据平台、数据治理工具、分析建模工具、应用开发工具，贯穿数据的存算、分析、应用、展示全生命周期，是新时代信息领域的“大国重器”。',
    productions: [
      { index: 1, content: '伏羲' },
      { index: 2, content: '盘古' },
      { index: 3, content: '淘沙' },
      { index: 4, content: '应用开发工具集' }
    ],
    // otherProductions: [
    //   { index: 1, content: '星渠' },
    //   { index: 2, content: '星梦' },
    //   { index: 3, content: '星轨' },
    //   { index: 4, content: '星绘' }
    // ],
    key: 'BigData'
  },
  {
    index: 2,
    icon: proIcon2,
    iconActive: proIconHover2,
    title: '电子取证产品',
    content:
      '构建多源数据采集接入能力、贴合业务场景的取证分析能力，打造了“多场景、多形态、高性能、高产出” 的电子取证产品体系，满足现场勘查、终端取证、证据分析、电子物证实验室等各类业务场景。',
    productions: [
      { index: 1, content: '"烽"' },
      { index: 2, content: '"鹰"' },
      { index: 3, content: '综合取证' },
      { index: 4, content: '取证分析' }
    ],
    key: 'ElectronicForensicsProducts'
  },
  {
    index: 3,
    icon: proIcon3,
    iconActive: proIconHover3,
    title: '数据分析服务',
    content:
      '由数据分析团队为用户提供专业的一线数据分析服务，充分赋能数据深度分析、区域会战、专项建模、专题研究等工作场景。',
    productions: [],
    key: 'DataAnalysisService'
  },
  {
    index: 4,
    icon: proIcon4,
    iconActive: proIconHover4,
    title: '数据运营服务',
    content:
      '以实践经验为底，不断沉淀、优化，为用户提供数据应用全生命流程的运营管理服务，助力用户快速构建业务核心数据资产，精准赋能价值落地。',
    productions: [],
    key: 'DataOperationService'
  }
]

const solutionList = [
  {
    index: 1,
    type: 'NetworkSafety',
    title: '网络安全',
    content:
      '通过各类感知设备搭载人工智能、大数据技术，打造多维感知、立体防控的智能感知系列解决方案，实现人脸、证件、音视频、指纹等信息的识别和分析，为基层执法人员的指挥调度、执法检查、活动安保等提供技术支撑。'
  },
  {
    index: 2,
    type: 'SmartPolicing',
    title: '智慧警务',
    content:
      '构建集强大计算能力、海量资源整合、高度信息共享、智能应用服务、严密安全保障、警务运行支撑“六大体系”于一体的全栈解决方案，全面助力构建服务全警，面向部、省、市、区县的智慧警务新型工作平台。'
  },
  {
    index: 3,
    type: 'SmartGovernment',
    title: '智慧政务',
    content:
      '基于政府信息化建设和数字化转型的需求，打造政务大数据平台、一网统管城市运行中心、公共卫生应急处置平台、政务一体化服务平台等一系列解决方案，助力各地数字政府的推进建设。'
  },
  {
    index: 4,
    type: 'SmartCommunity',
    title: '智慧社区',
    content:
      '面向基层管理人员打造覆盖物业管理、产量情况、人员出入、户籍迁移等一站式社区管理平台，为社区提供高质量、高效率服务，助力实现共建共治共享的智慧社区新格局。'
  },
  {
    index: 5,
    type: 'SmartComprehensiveInsurance',
    title: '智慧综保',
    content:
      '依托新一代信息技术，构建融合多种智慧监管场景的智慧综保解决方案，促进海关监管业务透明化、通关效率最大化，助推海关监管放得开、管得住。'
  },
  // {
  //     index: 6,
  //     type: 'SmartAntiSmuggling',
  //     title: '智慧缉私',
  //     content: '充分运用大数据、云计算等先进技术，汇聚公安网、海关网、互联网等多源数据，融合形成缉私情报数据仓库，通过线索发现、情报智判等科技手段，智能发现线索并深度挖掘，为打击走私提供有力支撑。'
  // },
  {
    index: 7,
    type: 'DigitalTransformation',
    title: '企业数字化转型',
    content:
      '运用云计算、大数据技术构建集采购、生产、营销、人力、财务等一体的数字化管理解决方案，助力企业管理者掌控日常运营全景，推动组织创新、协同办公，提升核心竞争力。'
  }
]

const aboutList = [
  {
    count: '1500',
    unit: '+',
    explanation: '业务覆盖区县'
  },
  {
    count: '2000',
    unit: '+',
    explanation: '服务案例'
  },
  {
    count: '25',
    unit: '个',
    explanation: '全国研发中心'
  },
  {
    count: '32',
    unit: '个',
    explanation: '技术服务中心'
  }
]

const Arrow = ({ ...rest }) => {
    return <span data-type={rest.type} style={rest.style} className={rest.className} onClick={rest.onClick} />
}

function HomePage() {

    // useTitle('烽火星空')

    const seeSolutionDetail = (type) => {
        if (type === 'tool') {
            // 跳转工具箱
            window.open(TOOLS.URL, '_blank')
        } else {
            type && window.open(`${window.location.origin}/solution?module=${type}`, '_blank')
        }

    }

    const seeProductionDetail = (type) => {
        window.open(`${window.location.origin}/production?type=${type}`, '_blank')
    }

    const seeRecommendDetail = (type) => {
        type && window.open(`${window.location.origin}/${type}`, '_blank')
    }

    return (
        <div className={styles['home']}>
            {/* <StyleProvider
                hashPriority='high'
                transformers={[legacyLogicalPropertiesTransformer]}
            > */}
            <Carousel
                autoplay
                autoplaySpeed={7000}
            // arrows={true}
            // prevArrow={<Arrow type="left" />}
            // nextArrow={<Arrow type="right" />}
            >
                {bannerList.map((item) => (
                    <div className={`${styles['banner']} ${styles['banner-' + item.index]}`} key={item.index}>
                        {/* {item.background ? (<video autoPlay loop muted src={item.background} />) : null} */}
                        <div className={styles['title']}>{item.title}</div>
                        <div className={styles['content']}>{item.content}</div>
                        <div className={styles['see-detail']} onClick={() => seeSolutionDetail(item.type)}>查看详情</div>
                    </div>
                ))}
            </Carousel>
            {/* </StyleProvider> */}
            <div className={styles['recommend']}>
                {recommendList.map((item) => (
                    <div className={styles['recommend-item']} key={item.index} onClick={() => seeRecommendDetail(item.key)}>
                        <img src={item.src} alt="" />
                        <div className={styles['recommend-content']}>
                            <p>{item.title}</p>
                            <p>{item.tip}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles['production']}>
                <div className={styles['title']}>专业、可靠、稳定的产品及服务</div>
                <div className={styles['sub-title']}>眸准数据，打造自主可控的大数据产品和服务体系
                    <Link target='_blank' to="/production">查看全部产品和服务&gt;</Link>
                </div>
                <div className={styles['production-container']}>
                    {productionList.map((item) => (
                        <div className={styles['production-item']} key={item.key}>
                            <div className={styles['production-item-container']} onClick={() => seeProductionDetail(item.key)}>
                                <div className={styles['production-icon']}>
                                    <img src={item.icon} alt="" />
                                    <img src={item.iconActive} alt="" />
                                </div>
                                <div className={styles['production-title']}>{item.title}</div>
                                <div className={styles['production-content']}>{item.content}</div>
                                <div className={styles['production-info']}>
                                    {item.productions.map((production) => (
                                        <span key={production.index}>{production.content}</span>
                                    ))}

                                </div>
                                {/* {
                                    item.otherProductions ? (
                                        <div className={styles['production-info']}>
                                            {item.otherProductions.map((production) => (
                                                <span key={production.index}>{production.content}</span>
                                            ))}
                                        </div>
                                    ) : null
                                } */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles['solution']}>
                <div className={styles['title']}>行业级大数据解决方案</div>
                <div className={styles['sub-title']}>针对行业特征，细分业务场景，打造全栈行业解决方案
                    <Link target='_blank' to="solution">查看全部解决方案&gt;</Link>
                </div>
                <div className={styles['solution-container']}>
                    {solutionList.map((item) => (
                        <div className={styles['solution-item']} key={item.index}>
                            <div className={styles['solution-title']}>{item.title}</div>
                            <div className={styles['solution-content']}>{item.content}</div>
                            <div className={styles['solution-detail']} onClick={() => seeSolutionDetail(item.type)}>查看详情 →</div>
                        </div>
                    ))}
                    {/* <div className={styles['solution-item']}>
                        <div className="solution-all-detail">
                            <Link target='_blank' to="solution">查看全部解决方案
                                <img src={arrowRight} alt="" />
                            </Link>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className={styles['about']}>
                <div className={styles['title']}>关于星空</div>
                <div className={styles['sub-title']}>网络空间安全和大数据领域的国家队</div>
                <div className={styles['about-container']}>
                    <div className={styles['about-content']}>
                        <p>
                        南京烽火星空通信发展有限公司是中国信科集团的重要组成成员，是网络安全与大数据领域的国家队。烽火星空依托自主可控的智能化大数据技术，致力于打造集资源、能力、服务、应用于一体的智能化大数据系列产品，创新了面向网络安全、公共安全、智慧城市三大领域的解决方案，推动数据化服务向各业务领域拓展延伸，助力用户构建以大数据智能应用为核心的业务新生态。
                        </p>
                    </div>
                    <div className={styles['about-tatistics']}>
                        {aboutList.map((item) => (
                            <div className={styles['about-statistics-item']} key={item.count}>
                                <p><span>{item.count}</span><span>{item.unit}</span></p>
                                <p>{item.explanation}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;